class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M5.267 14.067v-.936h-1.39a.942.942 0 0 1-.763-1.496l2.304-3.171h.002l1.246-1.715V1.933h1.866V6.75l.56.771 1.158.003-.784-1.075V1.933h.933V1H4.8v.933h.933v4.515l-3.373 4.64a1.876 1.876 0 0 0 1.517 2.979h1.39Z"></path><path d="M9.933 8.467H8.95l-1.816 3.056V8.467H6.2V15h.933v-2.002l.434-.695L8.95 15h.984l-1.815-3.533 1.815-3Zm1.867 5.6v-5.6h-.933V15H14.5v-.933h-2.7Z"></path></svg>';
  }
}
const t = "pi-klara";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
